<template>
  <div>
    <!--    <form-field-input-->
    <!--      label="Bedrooms"-->
    <!--      v-model="form.bedrooms"-->
    <!--      :validation-errors="validationErrors.bedrooms"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="Bathrooms"-->
    <!--      v-model="form.bathrooms"-->
    <!--      :validation-errors="validationErrors.bathrooms"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="HouseSize"-->
    <!--      v-model="form.house_size"-->
    <!--      :validation-errors="validationErrors.house_size"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="BasementSize"-->
    <!--      v-model="form.basement_size"-->
    <!--      :validation-errors="validationErrors.basement_size"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="LotSize"-->
    <!--      v-model="form.lot_size"-->
    <!--      :validation-errors="validationErrors.lot_size"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="YearBuilt"-->
    <!--      v-model="form.year_built"-->
    <!--      :validation-errors="validationErrors.year_built"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="Subdivision"-->
    <!--      v-model="form.subdivision"-->
    <!--      :validation-errors="validationErrors.subdivision"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="Stories"-->
    <!--      v-model="form.stories"-->
    <!--      :validation-errors="validationErrors.stories"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="ParkingType"-->
    <!--      v-model="form.parking_type"-->
    <!--      :validation-errors="validationErrors.parking_type"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="CoolingType"-->
    <!--      v-model="form.cooling_type"-->
    <!--      :validation-errors="validationErrors.cooling_type"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="HeatingType"-->
    <!--      v-model="form.heating_type"-->
    <!--      :validation-errors="validationErrors.heating_type"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="ConstructionType"-->
    <!--      v-model="form.construction_type"-->
    <!--      :validation-errors="validationErrors.construction_type"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="ArchitectureType"-->
    <!--      v-model="form.architecture_type"-->
    <!--      :validation-errors="validationErrors.architecture_type"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="Amenities"-->
    <!--      v-model="form.amenities"-->
    <!--      :validation-errors="validationErrors.amenities"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="MarketValue"-->
    <!--      v-model="form.market_value"-->
    <!--      :validation-errors="validationErrors.market_value"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="AssessedValue"-->
    <!--      v-model="form.assessed_value"-->
    <!--      :validation-errors="validationErrors.assessed_value"-->
    <!--    ></form-field-input>-->

    <!--    <form-field-input-->
    <!--      label="SearchableAddress"-->
    <!--      v-model="form.searchable_address"-->
    <!--      :validation-errors="validationErrors.searchable_address"-->
    <!--    ></form-field-input>-->

  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "PropertyInfoForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        line_1: null,
        city: null,
        county: null,
        state: null,
        postcode: null,
        postcode_ext: null,
        country_code: null,
      },
    }
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    update() {
      return this.$api.properties.updatePropertyInfo(this.form)
      .then(res => {
        this.$buefy.toast.open({
          message: 'Property was updated',
          type: 'is-success'
        });

            return res;
          });
    },
    create() {
      return this.$api.properties.create(this.form)
      .then(res => {
        this.$buefy.toast.open({
          message: 'Property was created',
          type: 'is-success'
        });

            return res;
          });
    },
    delete() {
      return this.$api.properties.delete(this.form.id)
      .then(res => {
        this.$buefy.toast.open({
          message: 'Property was archived',
          type: 'is-success'
        });

            return res;
          });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
